import { useState, type ReactNode } from 'react';
import { ConfirmDialog, Field, Input } from '@/components/ui';
import { useDeleteUser } from '@/hooks/useUsers';
import { toast } from '@/store/toastStore';
import type { UserSummary } from '@/types/api';
import { errorText } from '@/utils/errors';

/** Deleting an account for good, confirmed by typing its login. */
export function DeleteUserDialog({ user, onClose }: { readonly user: UserSummary | null; readonly onClose: () => void }): ReactNode {
  const [typed, setTyped] = useState('');

  const remove = useDeleteUser({
    onSuccess: () => {
      toast.success('Учётная запись удалена', 'Записи журнала о её действиях сохранены');
      setTyped('');
      onClose();
    },
  });

  return (
    <ConfirmDialog
      open={user !== null}
      title="Удалить учётную запись?"
      description={
        user
          ? `Учётная запись ${user.login} будет удалена без возможности восстановления. Для временной блокировки используйте отключение.`
          : undefined
      }
      confirmLabel="Удалить насовсем"
      destructive
      busy={remove.isPending}
      error={remove.isError ? errorText(remove.error, 'Не удалось удалить учётную запись') : undefined}
      onConfirm={() => user && remove.mutate({ id: user.id, confirmation: typed.trim() })}
      onClose={() => {
        setTyped('');
        remove.reset();
        onClose();
      }}
    >
      <div className="stack">
        <p className="field-hint">
          Записи журнала и созданные сайты сохраняются.
        </p>
        <Field label="Для подтверждения введите логин" htmlFor="remove-user-confirm" hint={user?.login ?? ''}>
          <Input
            id="remove-user-confirm"
            value={typed}
            onChange={(event) => setTyped(event.target.value)}
            placeholder={user?.login ?? ''}
            autoComplete="off"
          />
        </Field>
      </div>
    </ConfirmDialog>
  );
}
